var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D92D20"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3845_17108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.332 14.3809L32.6654 32.7142",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.332 14.3809L32.6654 32.7142",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9987 16.0469H25.9987L27.6654 18.5469H30.9987C31.4407 18.5469 31.8646 18.7225 32.1772 19.035C32.4898 19.3476 32.6654 19.7715 32.6654 20.2135V27.9969M26.232 26.2802C25.9554 26.6844 25.5932 27.0227 25.171 27.271C24.7489 27.5193 24.2772 27.6716 23.7895 27.7169C23.3018 27.7622 22.8101 27.6995 22.3495 27.5332C21.8888 27.3669 21.4704 27.1012 21.124 26.7549C20.7777 26.4085 20.512 25.9901 20.3457 25.5295C20.1794 25.0688 20.1167 24.5771 20.162 24.0894C20.2074 23.6017 20.3596 23.13 20.6079 22.7079C20.8562 22.2857 21.1945 21.9235 21.5987 21.6469M30.9987 31.0469H15.9987C15.5567 31.0469 15.1327 30.8713 14.8202 30.5587C14.5076 30.2462 14.332 29.8222 14.332 29.3802V20.2135C14.332 19.7715 14.5076 19.3476 14.8202 19.035C15.1327 18.7225 15.5567 18.5469 15.9987 18.5469H18.4987L30.9987 31.0469Z",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9987 16.0469H25.9987L27.6654 18.5469H30.9987C31.4407 18.5469 31.8646 18.7225 32.1772 19.035C32.4898 19.3476 32.6654 19.7715 32.6654 20.2135V27.9969M26.232 26.2802C25.9554 26.6844 25.5932 27.0227 25.171 27.271C24.7489 27.5193 24.2772 27.6716 23.7895 27.7169C23.3018 27.7622 22.8101 27.6995 22.3495 27.5332C21.8888 27.3669 21.4704 27.1012 21.124 26.7549C20.7777 26.4085 20.512 25.9901 20.3457 25.5295C20.1794 25.0688 20.1167 24.5771 20.162 24.0894C20.2074 23.6017 20.3596 23.13 20.6079 22.7079C20.8562 22.2857 21.1945 21.9235 21.5987 21.6469M30.9987 31.0469H15.9987C15.5567 31.0469 15.1327 30.8713 14.8202 30.5587C14.5076 30.2462 14.332 29.8222 14.332 29.3802V20.2135C14.332 19.7715 14.5076 19.3476 14.8202 19.035C15.1327 18.7225 15.5567 18.5469 15.9987 18.5469H18.4987L30.9987 31.0469Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3845_17108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13.5 13.5469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/camera-off.b4e8dc2396e634e94aad44dc2fff7e7e.svg";
export { ForwardRef as ReactComponent };